import React, { useEffect, useState } from 'react';
import { useUser } from '../../UserContext';

import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Alert from '@mui/material/Alert';

import { useAuth } from '../../AuthContext';

// services
import { getCustomerInformation } from '../../services/userService';

export default function CustomerInformation(props) {
  const { auth } = useAuth();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [customerInfo, setCustomerInfo] = useState(null);

  const handleClickOpen = () => {
    getCustomerInformation(props.customerId, auth).then((customerInfo) => {
      if (customerInfo) {
        setCustomerInfo(customerInfo);
      }
    }).catch(() => {
      setError(true);
    });

    setOpen(true);
  };

  const handleClose = () => {
    setError(false);
    setOpen(false);
  };

  return (
    <div>
      <label 
        onClick={handleClickOpen}
        style={{ 
          color: '#1976d2', 
          cursor: 'pointer', 
          textDecoration: 'none'
        }}
      >
        Customer Information
      </label>
      
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        { error ? (<Alert severity="error">Sorry, an error occurred while retrieving data!</Alert>) : ''}
        <DialogTitle id="responsive-dialog-title" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <div>Contact Information</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <strong>Customer Name:</strong>
                <span>{customerInfo? (customerInfo?.firstName + ' ' + customerInfo?.lastName) : 'N/A'}</span>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <strong>Phone:</strong>
                <span>{customerInfo?.phoneNumber || 'N/A'}</span>
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <strong>Email:</strong>
                <span>{customerInfo?.email || 'N/A'}</span>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} style={{ textTransform: 'none'}}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}